export const ShortcutEnum = {
    TODAY: "TODAY",
    LAST_7_DAYS: "LAST_7_DAYS",
    LAST_3_DAYS: "LAST_3_DAYS",
    LAST_5_DAYS: "LAST_5_DAYS",
    LAST_31_DAYS: "LAST_31_DAYS",
    CURRENT_MONTH: "CURRENT_MONTH",
    PREVIOUS_MONTH: "PREVIOUS_MONTH",
    LAST_YEAR: "LAST_YEAR",
    CURRENT_YEAR: "CURRENT_YEAR",
    PREVIOUS_YEAR: "PREVIOUS_YEAR",
    IN_THE_PAST: "IN_THE_PAST",
    IN_THE_FUTURE: "IN_THE_FUTURE"
} as const;

export type ShortcutEnum = typeof ShortcutEnum[keyof typeof ShortcutEnum];
